import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import RadixDialog from '../../../../../shared/RadixDialog';
import { ChangeDate } from '../ChangeDate.jsx';
import { useUpdatePostMutation } from './usePostMutation';
import { EDIT } from '../../../utils/constants';

export const useChangePostDate = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPost, setCurrentPost] = useState(null);
  const [currentCampaignId, setCurrentCampaignId] = useState(null);
  const { updatePostMutation } = useUpdatePostMutation();
  const { t } = useTranslation('posts');

  const openChangeDateModal = ({ post, campaignId }) => {
    setCurrentPost(post);
    setCurrentCampaignId(campaignId);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setCurrentPost(null);
    setCurrentCampaignId(null);
  };

  const handleSave = ({
    publishDate,
    sendHour,
    reminderDate,
    reminderSendHour,
  }) => {
    updatePostMutation({
      campaignId: currentCampaignId,
      publishDate,
      id: currentPost.uuid,
      sendHour,
      reminderDate,
      reminderSendHour,
    });
    handleClose();
  };

  const ChangePostDateModal = () => {
    if (!isOpen || !currentPost) return null;

    return (
      <RadixDialog
        isOpen={isOpen}
        onClose={handleClose}
        title={t('editPostDate')}
      >
        <ChangeDate
          campaignId={currentCampaignId}
          origin={EDIT}
          prize={currentPost.prize}
          publishDate={currentPost.publishDate}
          postSendHour={currentPost.sendHour}
          handleCancel={handleClose}
          handleSave={handleSave}
        />
      </RadixDialog>
    );
  };

  return { openChangeDateModal, ChangePostDateModal };
};
